// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { PrimaNotaRigaDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class PrimaNotaRigaApiClient extends BaseCRUDApiClient<PrimaNotaRigaDto> {
  baseUrl = this.config.apiEndpoint + '/prima-nota-riga';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }

  deleteRegistrazioni() {
    this._pagedCache.clear();
    return this.http.delete(`${this.baseUrl}/delete-registrazioni`);
  }
}
